<template>
  <van-popup
    v-model="showTimePopup"
    round
    position="bottom"
    :style="{ height: '50%' }"
  >
    <van-datetime-picker
      :value="currentDate"
      type="time"
      :title="typeTime"
      :formatter="formatter"
      @confirm="handleTimeConfirm"
      @cancel="showTimePopup = false"
    />
  </van-popup>
</template>

<script>
import moment from "moment";

export default {
  // props: ['currentDate', 'maxDate', 'minDate'],
  props: {
    currentDate: {
      default: () => {
        return "";
      },
    },
    type: {
      default: () => {
        return "datetime";
      },
    },
    maxDate: {},
    minDate: {},
    isFilter: {
      default: () => {
        return true;
      },
    },
    typeTime: {},
  },

  watch: {
    currentDate() {},
  },
  data() {
    return {
      showTimePopup: false,
      // minDate: new Date(),
      // curDate: this.currentDate && this.currentDate,
      // maxDate: this.maxDate && this.maxDate,
      // selectTime: null,
    };
  },
  methods: {
    filter(type, options) {
      if (!this.isFilter) {
        return options;
      }
      if (type === "minute") {
        return options.filter((option) => option % 10 === 0);
      }
      //  获取当前分钟，添加进数组,判断为一位添加进第一项
      // const m = moment().format('m')
      // if (m.length === 1 && type === 'minute') {
      //   return [m, 10, 20, 30, 40, 50]
      // }
      // if (m.length > 1 && type === 'minute') {
      //   let res = []
      //   const start = Number(m[0] + `0`) + 10
      //   for (let i = start; i <= 50; i += 10) {
      //     res.push(i)
      //   }
      //   return [m, ...res]
      // }
      return options;
    },
    handleTimeConfirm(value) {
      this.$emit("time", moment(moment().format('YYYY-MM-DD') + ' ' + value).format("HH:mm"));
      this.showTimePopup = false;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      if (type === "hour") {
        return val + "时";
      }
      if (type === "minute") {
        return val + "分";
      }
      return val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
